const config = {
  defaultWeeksAhead: 12,
  shippingDelay: 5,
  giftScheduleHour: 14,
};

export default config;
